import { render, staticRenderFns } from "./BankTransactionsSidebar.vue?vue&type=template&id=0696cddc&scoped=true&"
import script from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
export * from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactionsSidebar.vue?vue&type=style&index=0&id=0696cddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696cddc",
  null
  
)

export default component.exports